// extracted by mini-css-extract-plugin
export default {"visually_hidden":"SettingsLink_visually_hidden__trYtY","link":"SettingsLink_link__ieiFd","link_content":"SettingsLink_link_content__cbVRm"};